export default "__VITE_ASSET__CIj_Fs5X__"